export async function runTalkboxFunctions(data) {
	let returnData = '';
	const formData = new FormData();

	for (const [key, value] of Object.entries(data)) {
		formData.append(key, value);
	}

	try {
		const response = await fetch(igniteAjax.ajaxurl, {
			method: 'POST',
			body: formData
		});

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}

		returnData = await response.json();
	} catch (error) {
		console.error('Error:', error);
		returnData = { success: false, error: true };
	}

	return returnData;
}
